module.exports = __webpack_public_path__ + "img/server.e9df1296.svg";